if(current_user_type == "wholesaler") {
    document.querySelector('.user_type_selector').style.backgroundColor = '#775D46';
   document.querySelector('.footer').style.backgroundColor = '#775D46';  
   document.querySelector('.link').style.backgroundColor = '#775D46';  
    // /document.getElementsByClassName('.square').style.backgroundColor = '#775D46';
 
     document.querySelector('.list-menu__item').style.color = '#775D46';
    const element = document.querySelector(".list-menu--inline")
     element.removeChild(element.lastElementChild);
        document.getElementById('cart-icon-bubble').style.display = 'block';

  
     
 }
